import { Instagram, Linkedin, Star } from "lucide-react";
import { BUSINESS } from "@/data/site";

const BRANDS = [
  {
    id: "instagram",
    label: "Instagram",
    href: BUSINESS.social.instagram,
    Icon: Instagram,
    background:
      "radial-gradient(circle at 30% 110%, #fdf497 0%, #fd5949 45%, #d6249f 60%, #285AEB 90%)",
  },
  { id: "linkedin", label: "LinkedIn", href: BUSINESS.social.linkedin, Icon: Linkedin, background: "#0A66C2" },
  { id: "yelp", label: "Yelp", href: BUSINESS.social.yelp, Icon: Star, background: "#FF1A1A" },
];

export default function SocialLinks({ testIdPrefix, boxClass = "w-9 h-9", iconSize = 15 }) {
  return (
    <>
      {BRANDS.map(({ id, label, href, Icon, background }) => (
        <a
          key={id}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          data-testid={`${testIdPrefix}-${id}`}
          style={{ background }}
          className={`inline-flex items-center justify-center rounded-[5px] text-white shadow-sm hover:brightness-110 hover:-translate-y-0.5 transition ${boxClass}`}
        >
          <Icon size={iconSize} aria-hidden="true" />
        </a>
      ))}
    </>
  );
}
